import React, { useEffect, useState } from "react";
import axios from "axios";
import TopNav from "../../components/navigation/TopNav";
import { useTranslation } from "react-i18next";
import { maskLogNotes } from "../../components/helpers/maskHelpers";

import StandardScreen, { ScreenContent } from "../../components/layout/StandardScreen";
import Stack from "../../components/layout/Stack";
import Card from "../../components/ui/Card";
import {
  TableShell,
  Table,
  Th,
  Td,
  NumberTd,
} from "../../components/data/Table";

const narrowShellStyle = {
  width: "100%",
  margin: "0 auto",
};

export default function UserPendingRequestReport() {
  const { t } = useTranslation();
  const [requests, setRequests] = useState([]);

  const fetchRequests = async () => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/user/pending-requests`);
      setRequests(res.data);
    } catch (error) {
      console.error("Error fetching pending transfer requests:", error);
      setRequests([]);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  return (
    <StandardScreen
      topNav={<TopNav title={t("user_pending_requests_report.title")} mode="main" />}
    >
      <ScreenContent>
        <div style={narrowShellStyle}>
          <Stack gap="4">

            <Card title={t("user_pending_requests_report.title")}>

              {requests.length === 0 ? (
                <div>{t("user_pending_requests_report.messages.empty")}</div>
              ) : (
                <TableShell maxHeight="65vh">
                  <Table>


<thead>
  <tr>
    <Th columnIndex={0} sticky>
      {t("user_pending_requests_report.table.request_id")}
    </Th>

    <Th columnIndex={1} sticky>
      {t("user_pending_requests_report.table.time")}
    </Th>

    <Th>{t("user_pending_requests_report.table.owner")}</Th>
    <Th>{t("user_pending_requests_report.table.from_wallet")}</Th>

    <Th align="right">
      {t("user_pending_requests_report.table.delta_tickets_from")}
    </Th>

    <Th align="right">
      {t("user_pending_requests_report.table.delta_money_from")}
    </Th>

    <Th>{t("user_pending_requests_report.table.to_wallet")}</Th>

    <Th align="right">
      {t("user_pending_requests_report.table.delta_tickets_to")}
    </Th>

    <Th align="right">
      {t("user_pending_requests_report.table.delta_money_to")}
    </Th>

    <Th>{t("user_pending_requests_report.table.status")}</Th>

    <Th>{t("user_pending_requests_report.table.notes")}</Th>
  </tr>
</thead>

<tbody>
  {requests.map((r) => (
    <tr key={r.treq_id}>
      <Td columnIndex={0} sticky>{r.treq_id}</Td>
      <Td columnIndex={1} sticky>
        {new Date(r.created_at)
          .toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })
          .replace(",", "")}
      </Td>

      <Td>{r.owner_id}</Td>
      <Td>{r.from_wallet_id}</Td>
      <NumberTd>{r.delta_tickets_from_wallet}</NumberTd>
      <NumberTd>{r.delta_money_from_wallet}</NumberTd>
      <Td>{r.to_wallet_id}</Td>
      <NumberTd>{r.delta_tickets_to_wallet}</NumberTd>
      <NumberTd>{r.delta_money_to_wallet}</NumberTd>
      <Td>{t(`status_dropdown.values.${r.status}`)}</Td>
      <Td>{maskLogNotes(r.notes)}</Td>
    </tr>
  ))}
</tbody>


                  </Table>
                </TableShell>
              )}

            </Card>

          </Stack>
        </div>
      </ScreenContent>
    </StandardScreen>
  );
}